import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import * as RolService from 'services/rol.service'

import { CodigosTransaccionesConstant } from 'constants/index'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Roles' }]

const tableHeaderRows = [{ label: 'NOMBRE' }, { label: '', width: 60 }]

const ListaRolesPage = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const [duplicarModal, setDuplicarModal] = React.useState(false)
  const [idDuplicado, setIdDuplicado] = React.useState('')

  const tablaRef = React.useRef(null)

  const handleEditarClick = React.useCallback(
    async ({ _id }) => {
      history.push(`/${CodigosTransaccionesConstant.ROLES_NUEVO}/${_id}`)
    },
    [history]
  )

  const clickNuevo = React.useCallback(async () => {
    history.push(`/${CodigosTransaccionesConstant.ROLES_NUEVO}`)
  }, [history])

  const clickEliminarHandler = React.useCallback(
    async ({ _id }) => {
      await RolService.eliminarRol(_id)
        .then(() => {
          __zariContext.snack('success', 'Registro eliminado!')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickDuplicarHandler = React.useCallback(async ({ _id }) => {
    setIdDuplicado(_id)
    setDuplicarModal(true)
  }, [])

  const rowTemplate = React.useCallback(
    row => (
      <Table.Row hover key={row._id}>
        <Table.Cell>{row.nombre}</Table.Cell>
        <Table.Cell>
          <Table.Dropdown>
            {({ handleClose }) => [
              <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => handleEditarClick({ _id: row._id })}>
                Editar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminarHandler({ _id: row._id })}>
                Eliminar
              </Table.Dropdown.Item>,
              <Table.Dropdown.Item key='duplicar' handleClose={handleClose} onClick={e => clickDuplicarHandler({ _id: row._id })}>
                Duplicar
              </Table.Dropdown.Item>
            ]}
          </Table.Dropdown>
        </Table.Cell>
      </Table.Row>
    ),
    [handleEditarClick, clickEliminarHandler, clickDuplicarHandler]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Roles' breadcrumbs={portletBreadcrumbs} buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} />
        <Portlet.Body>
          <Table.ServerSide useNest={true} ref={tablaRef} url='/roles' headRows={tableHeaderRows} rowTemplate={rowTemplate} />
        </Portlet.Body>
      </Portlet>
      {duplicarModal && (
        <Modals.DuplicarModal
          idDuplicado={idDuplicado}
          show={duplicarModal}
          handleClose={() => setDuplicarModal(false)}
          reloadTable={() => tablaRef.current.reload()}
        />
      )}
    </>
  )
}

export default ListaRolesPage
